import { FC, ReactNode } from "react";
import styled from "@emotion/styled";
import { CSSObject } from "@emotion/react";

type Props = {
  level?: "1" | "2" | "3" | "4" | "5" | "6";
  theme?: "LIGHT" | "DARK";
  children?: ReactNode;
  style?: any;
  localStyles?: CSSObject;
};

const Heading: FC<Props> = ({
  level = "1",
  children,
  theme = "LIGHT",
  localStyles,
  ...props
}) => {
  const HeadingTag = `h${level}` as keyof JSX.IntrinsicElements;

  const Inner = styled(HeadingTag)<Props>(({ level, theme, localStyles }) => ({
    margin: 0,
    WebkitFontSmoothing: "antialiased",
    fontWeight: "400",
    MozOsxFontSmoothing: "grayscale",
    fontFamily: "'Jersey 20', Akshar, sans-serif",
    lineHeight: 1,
    color: "var(--dark-1000)",
    textTransform: "uppercase",
    fontStyle: "normal",

    ...(theme === "LIGHT" && {
      color: "var(--light-1000)",
    }),
    ...(theme === "DARK" && {
      color: "var(--dark)",
    }),
    ...(level === "1" && {
      fontSize: 72,
      letterSpacing: -3,
      textShadow: "0 3px rgba(0,0,0,0.3)",
    }),
    ...(level === "2" && {
      fontSize: 60,
      letterSpacing: -2,
      textShadow: "0 3px rgba(0,0,0,0.3)",
    }),
    ...(level === "3" && {
      fontSize: 48,
      letterSpacing: -1.5,
      textShadow: "0 3px rgba(0,0,0,0.3)",
    }),
    ...(level === "4" && {
      fontSize: 36,
      letterSpacing: -1,
      textShadow: "0 2px rgba(0,0,0,0.3)",
    }),
    ...(level === "5" && {
      fontSize: 24,
      textShadow: "0 2px rgba(0,0,0,0.3)",
    }),
    ...(level === "6" && {
      fontSize: 21,
      textShadow: "0 2px rgba(0,0,0,0.3)",
    }),
    ...localStyles,
  }));

  return (
    <Inner level={level} theme={theme} localStyles={localStyles} {...props}>
      {children}
    </Inner>
  );
};

export default Heading;
